import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Grid,
  Paper,
  MenuItem,
  InputAdornment
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import iconLoad from "../../img/form-loading.gif";
import PhoneIcon from '@mui/icons-material/Phone';
import CircularProgress from '@mui/material/CircularProgress';
import { it } from 'date-fns/locale';
import { getName, getCodes } from 'country-list';
import axios from 'axios';
import { MuiTelInput } from 'mui-tel-input'
import {useTranslation} from "react-i18next";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useEffect} from 'react';
import backendApi from "../utils/BackendApi.js";


const countryCodes = getCodes();
const countries = countryCodes.map((countryCode) => ({
  value: countryCode,
  label: getName(countryCode),
}));

const UserRegistrationComponent = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    birthDate: null,
    nationality: '',
    password: '',
    confirmPassword: '',
    vatNumber: '',  // Partita IVA
    companyName: '', // Ragione Sociale
  });

  const [errors, setErrors] = useState({});
  const [showCodeConfirmation, setShowCodeConfirmation] = useState(false);
  const [birthDate, setBirthDate] = useState(null);
  const [t,i18n] = useTranslation("global");
  const [loading, setLoading] = useState(false);

  const loadingLogin = document.getElementById('loading-login');
  const buttonSubmit = document.getElementById('submit');

  //Loading
  const setShowLoadingOnForm = (display=true) => {
    if(display){
      loadingLogin.style.display = 'block';
      buttonSubmit.disabled = true;
    }else{
      loadingLogin.style.display = 'none';
      buttonSubmit.disabled = false;
    }
  }

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({ ...prev, birthDate: date }));
  };

  const isPasswordValid = (password) => {
    // Almeno 8 caratteri, almeno una maiuscola, una minuscola, un numero e un simbolo
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return regex.test(password);
  };


  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim() && !formData.companyName.trim()) {
      newErrors.firstName = t("UserRegistrationComponent.mandatoryNameOrCompany");
      newErrors.companyName = t("UserRegistrationComponent.mandatoryNameOrCompany");
    }

    if (!formData.lastName.trim() && !formData.companyName.trim()) {
      newErrors.lastName = t("UserRegistrationComponent.mandatoryNameOrCompany");
      newErrors.companyName = t("UserRegistrationComponent.mandatoryNameOrCompany");
    }

    if (formData.firstName.trim() && !formData.lastName.trim()) {
      newErrors.lastName = t("UserRegistrationComponent.mandatorySurname");
    }
    if (formData.lastName.trim() && !formData.firstName.trim()) {
      newErrors.firstName = t("UserRegistrationComponent.mandatoryName");
    }
    if (!formData.firstName.trim()) newErrors.firstName = t("UserRegistrationComponent.mandatoryName");
    if (!formData.lastName.trim()) newErrors.lastName = t("UserRegistrationComponent.mandatorySurname");
    if (!/^\d{11}$/.test(formData.vatNumber)) {
      newErrors.vatNumber = t("UserRegistrationComponent.invalidVat");
    }

    if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) newErrors.email = t("UserRegistrationComponent.mandatoryEmail");
    if (!formData.phone.trim()) newErrors.phone = t("UserRegistrationComponent.mandatoryPhone");
    if (!formData.birthDate) newErrors.birthDate = t("UserRegistrationComponent.mandatoryBDay");
    if (!formData.nationality) newErrors.nationality = t("UserRegistrationComponent.mandatoryNationality");
    if (formData.password.length < 6) newErrors.password = t("UserRegistrationComponent.minLenght");
    if (!isPasswordValid(formData.password)) {
      newErrors.password = t("UserRegistrationComponent.invalidPassword");
      toast.error(t("UserRegistrationComponent.invalidPassword"));
      return false;
    }

    if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = t("UserRegistrationComponent.mandatoryPasswordMatch");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
        // Date manipulation
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        const formattedDate = formData.birthDate.toLocaleDateString('en-US', options).replace(',', '');

        console.log("VAT prima: ", formData.vatNumber);
        // Create the JSON object
        const userData = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            birthday: formattedDate,
            nationality: formData.nationality,
            phone: formData.phone,
            password: formData.password,
            matchingPassword: formData.confirmPassword,
            vatNumber: formData.vatNumber,  // Partita IVA
            companyName: formData.companyName, // Ragione Sociale
        };

        console.log("VAT dopo: ", userData.vatNumber);

        try {
            // Send the POST request using Axios
            setLoading(true);
//            const response = await axios.post('http://localhost:8080/registration', userData);
            const response = await backendApi.post('registration', userData);
            setShowCodeConfirmation(true);
            setLoading(false);
            toast.info(t("UserRegistrationComponent.registrationOk"), {
              onClose: () => {
                // Dopo che il primo toast si chiude, mostra il secondo
                toast.success(t("UserRegistrationComponent.confirmationLink"));
              }
            });
        } catch (error) {
            console.log(error);

            const errorCode = error.response?.data?.code;
            if (errorCode === "company.exists") {
              toast.error(t("UserRegistrationComponent.accountAlreadyExists"));
              setLoading(false);
              return false;
            }
            if (errorCode === "agent.exists") {
              toast.error(t("UserRegistrationComponent.agentAlreadyExists"));
              setLoading(false);
              return false;
            }

            const errorMessage = error.response.data.message;
            const messageToPrint = errorMessage.split('\n')[0];
            toast.error(messageToPrint);
            setLoading(false);
        }
    }
  };

  return (
    <>
    <ToastContainer
     position="top-center"
     autoClose={5000}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
     draggable
     pauseOnHover
    />
    <Container maxWidth="md">
      <Paper elevation={6} sx={{ padding: 4, marginTop: 8, borderRadius: 3}}>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2rem'}}>
            <Typography variant="h3" align="center" gutterBottom class="form_title">
              {t("UserRegistrationComponent.createAccount")}
            </Typography>
        </div>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                name="firstName"
                label={t("UserRegistrationComponent.name")}
                fullWidth
                value={formData.firstName}
                onChange={handleChange}
                error={!!errors.firstName}
                helperText={errors.firstName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="lastName"
                label={t("UserRegistrationComponent.surname")}
                fullWidth
                value={formData.lastName}
                onChange={handleChange}
                error={!!errors.lastName}
                helperText={errors.lastName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="companyName"
                label={t("UserRegistrationComponent.company")}
                fullWidth
                value={formData.companyName}
                onChange={handleChange}
                error={!!errors.companyName}
                helperText={errors.companyName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="vatNumber"
                label={t("UserRegistrationComponent.vatcode")}
                fullWidth
                value={formData.vatNumber}
                onChange={handleChange}
                error={!!errors.vatNumber}
                helperText={errors.vatNumber}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="email"
                label={t("UserRegistrationComponent.email")}
                type="email"
                fullWidth
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MuiTelInput
                value={formData.phone}
                onChange={(value) => setFormData({ ...formData, phone: value })}
                defaultCountry="IT"
                fullWidth
                label={t("UserRegistrationComponent.phone")}
                error={!!errors.phone}
                helperText={errors.phone}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={it}>
                   <DatePicker
                     label={t("UserRegistrationComponent.bday")}
                     value={formData.birthDate}
                     error={!!errors.birthDate}
                     helperText={errors.birthDate}
                     onChange={handleDateChange}
                     format="dd/MM/yyyy"
                     renderInput={(params) => (
                       <TextField
                         {...params}
                         fullWidth
                         error={!!errors.birthDate}
                         helperText={errors.birthDate}
                       />
                     )}
                   />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} sx={{width:'20%'}}>
              <TextField
                select
                name="nationality"
                label={t("UserRegistrationComponent.nationality")}
                fullWidth
                value={formData.nationality}
                onChange={handleChange}
                error={!!errors.nationality}
                helperText={errors.nationality}
              >
                {countries.map((option) => (
                  <MenuItem key={option.code} value={option.label}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="password"
                label={t("UserRegistrationComponent.password")}
                type="password"
                fullWidth
                value={formData.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="confirmPassword"
                label={t("UserRegistrationComponent.confirmPassword")}
                type="password"
                fullWidth
                value={formData.confirmPassword}
                onChange={handleChange}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
              />
            </Grid>
          </Grid>
        </Box>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '4rem'}}>
            {loading ? (
              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <CircularProgress sx={{ color: 'orange' }}/>
              </div>
            ) : (
              <button id="submit" className='btn orange' onClick={handleSubmit} style={{ backgroundColor: 'var(--orange)', color: 'white' }}>
                  {t("UserRegistrationComponent.signUp")}
              </button>
            )}
        </div>
      </Paper>
    </Container>
    </>
  );
};

export default UserRegistrationComponent;
